import { ServicePlanAssessmentAnchors } from 'components/Assessments/ServicePlanAssessment/constants/constants'
import { SocAssessmentAnchors } from 'components/Assessments/SocAssessment/constants'
import { PATAssessmentAnchors } from 'components/Assessments/PatAssessment/constants'
import { AssessmentType } from 'components/Clinical/Assessments/constants'
import { RecertAssessmentAnchors } from 'components/Assessments/RecertAssessment/constants'
import { FuaAssessmentAnchors } from 'components/Assessments/FuaAssessment/constants'
import { SupervisoryAssessmentAnchors } from 'components/Assessments/SupervisoryAssessment/constants'
import { DischargeAssessmentAnchors } from 'components/Assessments/DischargeAssessment/constants'
import { RocAssessmentAnchors } from 'components/Assessments/RocAssessment/constants'

export const AssessmentNames = {
  [AssessmentType.PAT]: 'Skilled Pediatric Assessment',
  [AssessmentType.SOC]: 'Start of Care Assessment',
  [AssessmentType.RECERT]: 'Recertification Assessment',
  [AssessmentType.FUA]: 'Follow-Up Assessment',
  [AssessmentType.SUPERVISORY]: 'Supervisory Assessment',
  [AssessmentType.DISCHARGE]: 'Discharge Assessment',
  [AssessmentType.ROC]: 'Resumption of Care Assessment',
  [AssessmentType.SERVICE_PLAN]: 'Service Plan Assessment'
}

export const assessmentAnchors = {
  [AssessmentType.PAT]: PATAssessmentAnchors,
  [AssessmentType.SOC]: SocAssessmentAnchors,
  [AssessmentType.RECERT]: RecertAssessmentAnchors,
  [AssessmentType.FUA]: FuaAssessmentAnchors,
  [AssessmentType.SUPERVISORY]: SupervisoryAssessmentAnchors,
  [AssessmentType.DISCHARGE]: DischargeAssessmentAnchors,
  [AssessmentType.ROC]: RocAssessmentAnchors,
  [AssessmentType.SERVICE_PLAN]: ServicePlanAssessmentAnchors
}
